<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div
          class="
            weui-cell weui-cell_active weui-cell_select weui-cell_select-after
          "
        >
          <div class="weui-cell__hd">
            <span class="weui-label">{{
              customLabel.ap_kind || "让利形式"
            }}</span>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.ap_kind"
              :disabled="!fromAdd"
            >
              <option :value="'返点'">返点</option>
              <option :value="'折扣'">折扣</option>
            </select>
          </div>
        </div>
        <agent-field
          slot="ap_agentname"
          :label="customLabel.ap_agentname || '代理商'"
          v-model="form.main.ap_agentname"
          @select="onSelectAgent"
        />
        <currency-field
          slot="ap_currency"
          :label="customLabel.ap_currency || '币种'"
          v-model="form.main.ap_currency"
          @select="onSelectCurrency"
        />
        <div class="weui-cell" slot="ap_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ap_taxrate || "税率%"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.ap_taxrate"
              placeholder="请填写税率"
            />
          </div>
        </div>
        <date-field
          slot="ap_startdate"
          :label="customLabel.ap_startdate || '生效日期'"
          v-model="form.main.ap_startdate"
        />
        <date-field
          slot="ap_enddate"
          :label="customLabel.ap_enddate || '失效日期'"
          v-model="form.main.ap_enddate"
        />
        <div class="weui-cell" slot="ap_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ap_remark || "备注"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ap_remark"
            />
          </div>
        </div>
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>物料{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              slot="pr_detail"
              :label="customLabel.pr_detail || '物料名称'"
              v-model="item.pr_detail"
              @select="onSelectProduct($event, item)"
            />
            <customer-field
              slot="apd_custname"
              :label="customLabel.apd_custname || '客户名称'"
              v-model="item.apd_custname"
              @select="onSelectCustomer($event, item)"
            />
            <div class="weui-cell" slot="apd_saleprice">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  form.main.ap_kind == "返点" ? "代理商价格" : "终端销售价"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.apd_saleprice"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="apd_coefficient">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  form.main.ap_kind == "返点" ? "返点点数%" : "折扣系数"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.apd_coefficient"
                  placeholder="0.00"
                />
              </div>
            </div>
            <div class="weui-cell" slot="apd_specialprice">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.apd_specialprice || "特价"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.apd_specialprice"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="apd_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.apd_qty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.apd_qty"
                  placeholder="0"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import AgentField from "@/components/field/AgentField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import DateField from "@/components/field/DateField.vue";
import ProductField from "@/components/field/ProductField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    AgentField,
    CurrencyField,
    DateField,
    ProductField,
    CustomerField,
  },
  mixins: [process],
  data() {
    var fromAdd = this.$route.params.id || this.$route.query.id ? false : true;
    return {
      baseUrl: "/api/agent/agentprice",
      codeField: "ap_code",
      statusField: "ap_statuscode",
      caller: "AgentPrice",
      xtype: "agent-agentprice-formpanel",
      form: {
        main: {
          ap_kind: "返点",
          ap_taxrate: 13,
        },
        items: [
          {
            apd_coefficient: 100,
            apd_status: 1,
          },
        ],
      },
      fromAdd,
    };
  },
  methods: {
    onSelectAgent(selection) {
      var me = this,
        main = me.form.main;
      main.ap_agentid = selection.id;
      main.ap_agentcode = selection.cu_code;
      main.ap_currency = selection.cu_currency;
      main.ap_rate = selection.cr_rate;
      main.ap_taxrate = selection.cu_taxrate;
    },
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.ap_rate = selection.cr_rate;
    },
    onSelectProduct(selection, item) {
      item.apd_prodid = selection.id;
      item.apd_prodcode = selection.pr_code;
      item.pr_detail = selection.pr_detail;
      item.pr_brand = selection.pr_brand;
      item.pr_orispeccode = selection.pr_orispeccode;
      item.pr_spec = selection.pr_spec;
      item.pr_unit = selection.pr_unit;
    },
    onSelectCustomer(selection, item) {
      item.apd_custid = selection.id;
      item.apd_custcode = selection.cu_code;
      item.apd_custname = selection.cu_name;
    },
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        apd_coefficient: 100,
        apd_status: 1,
      });
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.ap_agentname) {
        me.$weui.topTips("请选择代理商", 2000);
      } else if (!main.ap_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else if (!main.ap_startdate) {
        me.$weui.topTips("请选择生效日期", 2000);
      } else if (!main.ap_enddate) {
        me.$weui.topTips("请选择失效日期", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.pr_detail) {
            me.$weui.topTips(`第${count + 1}行物料未选择`, 2000);
            return false;
          } else if (!item.apd_custname) {
            me.$weui.topTips(`第${count + 1}行客户未填写`, 2000);
            return false;
          } else if (!item.apd_saleprice) {
            me.$weui.topTips(
              `第${count + 1}行代理商价格或终端销售价未填写`,
              2000
            );
          } else {
            count++;
            item.apd_detno = count;
            item.apd_price =
              item.apd_specialprice > 0
                ? item.apd_specialprice
                : (item.apd_saleprice * item.apd_coefficient) / 100;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
  },
};
</script>